import './Matches.scss';

import { useEffect, useState } from 'react';

import axios from 'axios';

const Matches = ({ bgImage, title }) => {
    let [matches, setMatches] = useState([]),
        styles = {
            backgroundImage: `url(${bgImage})`,
        };

    useEffect(() => {
        axios
            .get(
                'https://site.web.api.espn.com/apis/v2/navigation/11297817?lang=nl',
            )
            .then(function (response) {
                setMatches(response.data?.navigation?.items);
            })
            .catch(function (error) {
                console.log(error);
            });
    });

    return (
        <section id="matches" className="Matches" style={styles}>
            <div className="container">
                <h2 className="heading heading--medium heading--white text--center">
                    {title}
                </h2>
                <div className="Matches__featured">
                    {matches.map(match => {
                        let home = match.items[0].links[0],
                            away = match.items[1].links[0];

                        return (
                            <div className="Matches__row">
                                <div className="Matches__date text text--white">
                                    {match.text}
                                </div>
                                <div className="Matches__home text text--white">
                                    {home.text}
                                    <img
                                        className="Matches__logo"
                                        src={`https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/${home.attributes.teamId}.png`}
                                        alt={home.text}
                                    />
                                </div>
                                <div className="text text--white">-</div>
                                <div className="Matches__away text text--white">
                                    <img
                                        className="Matches__logo"
                                        src={`https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/${away.attributes.teamId}.png`}
                                        alt={away.text}
                                    />
                                    {away.text}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Matches;
